import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=9b499650&scoped=true&"
import script from "./MessageCard.vue?vue&type=script&lang=js&"
export * from "./MessageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b499650",
  null
  
)

export default component.exports